.root {
    composes: listReset from "../../styles/composable/utility.module.css";
    display: flex;
    gap: var(--spacer-4);
    margin-top: var(--spacer-80);
    margin-inline: var(--spacer-40);

    li {
        display: flex;
        align-items: center;
    }

    svg {
        margin-left: var(--spacer-4);
        width: 1em;
        height: 1em;
    }
}
